import { FC } from 'react';
import SidePanel from 'src/components/design-system/SidePanel';
import useWindowSize from 'src/hooks/useWindowSize';
import { useContextSelector } from 'use-context-selector';
import ViewInvoiceBudgetPeriodActions from '../view_invoice_budget_period/ViewInvoiceBudgetPeriodActions';
import ViewInvoiceBudgetPeriodMain from '../view_invoice_budget_period/ViewInvoiceBudgetPeriodMain';
import { InvoiceContext } from './InvoiceDetailsContext';

interface MultiPeriodAccountingProps {}

const MultiPeriodAccounting: FC<MultiPeriodAccountingProps> = () => {
  const isOpenMpa = useContextSelector(InvoiceContext, (value) => value.isOpenMpa);

  const handleCancelSidePanel = useContextSelector(
    InvoiceContext,
    (value) => value.handleCancelSidePanel
  );
  const { width } = useWindowSize();

  return (
    <SidePanel
      isOpen={isOpenMpa}
      onClose={handleCancelSidePanel}
      position="right"
      width={width < 950 ? `${width}px` : '950px'}
    >
      <ViewInvoiceBudgetPeriodActions />
      <ViewInvoiceBudgetPeriodMain />
    </SidePanel>
  );
};

export default MultiPeriodAccounting;
